// Import template icons
import ArticleLargeIcon from '../templates/ArticleLarge.svg';
import ArticleMediumIcon from '../templates/ArticleMedium.svg';
import EventCalendarMediumIcon from '../templates/EventCalendarMedium.svg';
import EventCalendarSmallIcon from '../templates/EventCalendarSmall.svg';
import InteractiveArticleLargeIcon from '../templates/InteractiveArticleLarge.svg';
import InteractiveArticleMediumIcon from '../templates/InteractiveArticleMedium.svg';
import LinkLargeIcon from '../templates/LinkLarge.svg';
import LinkMediumIcon from '../templates/LinkMedium.svg';
import MultiChoiceLargeIcon from '../templates/MultiChoicePollLarge.svg';
import MultiChoicePollMedium from '../templates/MultiChoicePollMedium.svg';
import PuzzleLargeIcon from '../templates/PuzzleLarge.svg';
import ShopLargeIcon from '../templates/ShopLarge.svg';
import ShopMediumIcon from '../templates/ShopMedium.svg';
import StorefrontLinkLargeIcon from '../templates/StorefrontLinkLarge.svg';
import StorefrontLinkMediumIcon from '../templates/StorefrontLinkMedium.svg';
import ThisOrThatLargeIcon from '../templates/ThisOrThatPollLarge.svg';
import ThisOrThatMediumIcon from '../templates/ThisOrThatPollMedium.svg';
import VideoLargeIcon from '../templates/VideoLarge.svg';
import VideoMediumIcon from '../templates/VideoMedium.svg';
import VoteSliderLargeIcon from '../templates/VoteSliderPollLarge.svg';
import VoteSliderMediumIcon from '../templates/VoteSliderPollMedium.svg';
import { TemplateId } from '@lifeserver/shared';

export const TEMPLATE_ICONS: Record<TemplateId, string> = {
    'article-static-medium': ArticleMediumIcon,
    'article-static-large': ArticleLargeIcon,
    'article-interactive-medium': InteractiveArticleMediumIcon,
    'article-interactive-large': InteractiveArticleLargeIcon,
    'link-medium': LinkMediumIcon,
    'link-large': LinkLargeIcon,
    'link-shop-medium': ShopMediumIcon,
    'link-shop-large': ShopLargeIcon,
    'link-storefront-medium': StorefrontLinkMediumIcon,
    'link-storefront-large': StorefrontLinkLargeIcon,
    'video-medium': VideoMediumIcon,
    'video-large': VideoLargeIcon,
    'poll-thisorthat-medium': ThisOrThatMediumIcon,
    'poll-thisorthat-large': ThisOrThatLargeIcon,
    'poll-voteslider-medium': VoteSliderMediumIcon,
    'poll-voteslider-large': VoteSliderLargeIcon,
    'poll-multichoice-medium': MultiChoicePollMedium,
    'poll-multichoice-large': MultiChoiceLargeIcon,
    'tile-puzzle-large': PuzzleLargeIcon,
    'event-calendar-small': EventCalendarSmallIcon,
    'event-calendar-medium': EventCalendarMediumIcon,
};
